import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";

export async function getPromotionListAPI(data) {
    return await  axiosClientStilo.get(data?.type === 'promo' ? `/api/v1/metrc/promotion/templates` : data?.type === 'reward' ? `/api/v1/metrc/reward/templates` : data?.type === 'taxes' ? `/api/v1/metrc/tax/templates` :data?.type === 'member' ? `/api/v1/metrc/member/templates`:data?.type === 'orders' ? `/api/v1/metrc/orders?${getQueryString(data)}`: "");
}


export async function addPromoDataAPI(data, type) {
    return await axiosClientStilo.post(type === 'Promotion' ? `/api/v1/metrc/promotion/templates` : type === 'Reward' ? `/api/v1/metrc/reward/templates` : type === 'Taxes' ? `/api/v1/metrc/tax/templates`:type === 'Member' ? `/api/v1/metrc/member/templates`: "", data);
}
// export async function deletePromoAPI(data,type) {
//     return await axiosClientStilo.delete(`/api/v1/metrc/promotion/templates/${data}`);
// }

export async function editPromoDataAPI(data, id, type) {
    return await axiosClientStilo.put(type === 'Promotion' ? `/api/v1/metrc/promotion/templates/${id}` : type === 'Reward' ? `/api/v1/metrc/reward/templates/${id}` : type === 'Taxes' ? `/api/v1/metrc/tax/templates/${id}` :type === 'Member' ? `/api/v1/metrc/member/templates/${id}`: "", data);
}

export async function deletePromoAPI(data, type) {
    return await axiosClientStilo.delete(type === 'promo' ? `/api/v1/metrc/promotion/templates/${data}` : type === 'reward' ? `/api/v1/metrc/reward/templates/${data}` : type === 'taxes' ? `/api/v1/metrc/tax/templates/${data}` :type === 'member' ? `/api/v1/metrc/member/templates/${data}`: "");
}
export async function fetchComplianceDataAPI() {
    return await axiosClientStilo.get(`/api/v1/metrc/compliance/fee`);
}

export async function addComplianceFeeDataAPI(data) {
    return await axiosClientStilo.post(`/api/v1/metrc/compliance/fee`, data);
}


export async function syncOrderAdminAPI(data) {
    return await axiosClientStilo.get(`/api/v1/metrc/generate/receipts?${getQueryString(data)}`);
}


export async function fetchDeliveryDataAPI() {
    return await axiosClientStilo.get(`/api/v1/metrc/delivery/fee`);
}
export async function addDeliveryFeeDataAPI(data) {
    return await axiosClientStilo.post(`/api/v1/metrc/delivery/fee`, data);
}
